import { UserConfig } from "./types";

export const defineMumiConfig:(config: UserConfig)=>UserConfig = (config) =>  config
